export function ExportSettings() {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
          Export & Backup Settings
        </h2>
        <p className="text-sm text-muted-foreground">
          Configure data export and backup options
        </p>
      </div>
      
      <div className="text-center py-12">
        <p className="text-muted-foreground">Export settings coming soon...</p>
      </div>
    </div>
  )
}